import(/* webpackMode: "eager" */ "__barrel_optimize__?names=ConfigProvider!=!/app/node_modules/antd/es/index.js");
import(/* webpackMode: "eager" */ "/app/src/components/ThemesProvider.tsx");
import(/* webpackMode: "eager" */ "/app/src/utils/style-registry/antd.tsx");
import(/* webpackMode: "eager" */ "/app/src/utils/style-registry/emotion.tsx")